import React, { Component, ReactElement } from 'react';
import { Checkbox, FormInstance, Radio, RadioChangeEvent } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { LineChartWidgetConfiguration, LineType } from '@methodset/application-client-ts';
import { Calculator } from '@methodset/calculator-ts';
import { Info } from 'components/Info/Info';
import { Spacer } from 'components/Spacer/Spacer';
import { CoreUtils } from 'utils/CoreUtils';
import { FormItem } from 'components/FormItem/FormItem';
import { Globals } from 'constants/Globals';
import update from 'immutability-helper';
import './LineChartEditor.less';

export type DefaultCallback = (configuration: LineChartWidgetConfiguration) => void;
export type ChangeCallback = (configuration: LineChartWidgetConfiguration) => void;

export type LineChartEditorProps = {
    formRef: React.RefObject<FormInstance>,
    configuration: LineChartWidgetConfiguration,
    calculator: Calculator,
    onDefault: DefaultCallback,
    onChange: ChangeCallback
}

export class LineChartEditor extends Component<LineChartEditorProps> {

    static DefaultConfiguration = {
        lineType: LineType.STRAIGHT
    } as LineChartWidgetConfiguration;

    constructor(props: LineChartEditorProps) {
        super(props);
        this.handleLineChange = this.handleLineChange.bind(this);
        this.handleMarkersChange = this.handleMarkersChange.bind(this);
    }

    private handleLineChange(e: RadioChangeEvent): void {
        const lineType = e.target.value;
        const configuration = update(this.props.configuration, {
            lineType: { $set: lineType }
        });
        this.props.onChange(configuration);
    }

    private handleMarkersChange(e: CheckboxChangeEvent): void {
        const hasMarkers = e.target.checked;
        const configuration = update(this.props.configuration, {
            hasMarkers: { $set: hasMarkers }
        });
        this.props.onChange(configuration);
    }

    public componentDidMount(): void {
        this.props.onDefault(LineChartEditor.DefaultConfiguration);
    }

    public render(): ReactElement {
        return (
            <Spacer direction="vertical">
                <FormItem
                    {...Globals.FORM_LAYOUT}
                    formRef={this.props.formRef}
                    required={true}
                    label="Line Type"
                    name="line"
                    info="The type of line to connect data points."
                >
                    <Radio.Group
                        buttonStyle="solid"
                        value={this.props.configuration.lineType}
                        onChange={this.handleLineChange}
                    >
                        {LineType.array().map(type => (
                            <Radio key={type} value={type}>{CoreUtils.toProper(type)}</Radio>
                        ))}
                    </Radio.Group>
                </FormItem>
                <Checkbox
                    checked={this.props.configuration.hasMarkers}
                    onChange={this.handleMarkersChange}
                >
                    <Info
                        label="Show Markers"
                        info="True to show data points with a marker."
                        bold={true}
                    />
                </Checkbox>
            </Spacer>
        );
    }

}
